export default __webpack_public_path__ + "static/media/image-bid-email.544abf58.png";